import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import EditModal from '../../components/infrastructure/Modals/EditModal';
import { ClipLoader } from 'react-spinners';
import { useFormik } from 'formik';
import FormikInputGroup from '../../components/formik/FormikInputGroup';
import PrimaryButton from '../../components/infrastructure/Buttons/PrimaryButton';
import {
    editPaymentTerms,
    fetchPaymentTerms,
    fetchPaymentTerm,
    getPaymentTerm,
    setEditId,
} from '../../app/reducers/PaymentTerms/paymentTermSLice';
import * as Yup from 'yup';

const EditPaymentTermsModal = () => {
    const { elementEditId, elementEditData, editDataLoading } =
        useSelector(getPaymentTerm);
    const dispatch = useDispatch();
    const formik = useFormik({
        enableReinitialize: true,
        initialValues: elementEditData,
        validationSchema: Yup.object({
            name: Yup.string().required(),
            value: Yup.number().required(),
            percentage: Yup.string().required(),
        }),
        onSubmit: async (values, { resetForm }) => {
            await dispatch(editPaymentTerms(values));
            resetForm();
            dispatch(setEditId(null));
            dispatch(fetchPaymentTerms());
        },
    });

    return (
        <EditModal
            editProperty={elementEditId}
            setEditProperty={setEditId}
            getEditData={fetchPaymentTerm}
            title="Edit Payment Term"
        >
            {editDataLoading ? (
                <ClipLoader />
            ) : (
                <form
                    onSubmit={formik.handleSubmit}
                    className="flex flex-col gap-2 p-4"
                >
                    <FormikInputGroup
                        label="SystemId"
                        name="_id"
                        formik={formik}
                        required
                        readOnly
                    />
                    <FormikInputGroup
                        label="Name"
                        name="name"
                        formik={formik}
                        required
                    />
                    <FormikInputGroup
                        label="Value"
                        name="value"
                        formik={formik}
                        required
                    />
                    <FormikInputGroup
                        label="Percentage"
                        formik={formik}
                        name="percentage"
                        required
                    />
                    <div>
                        <PrimaryButton type="submit">Submit</PrimaryButton>
                    </div>
                </form>
            )}
        </EditModal>
    );
};

export default EditPaymentTermsModal;
